<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'nav.characters' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="re-hub-scroll re-tab-hub">
  <div class="re-tab-hub__shell">
    <h1 class="re-visually-hidden">{{ 'nav.characters' | translate }}</h1>
    <div class="re-segment-wrap">
      <ion-segment [value]="segment()" (ionChange)="onSegmentChange($event)" mode="ios" class="re-segment">
        <ion-segment-button value="sheets">{{ 'common.sheets' | translate }}</ion-segment-button>
        <ion-segment-button value="templates">{{ 'common.templates' | translate }}</ion-segment-button>
      </ion-segment>
    </div>

    <div class="characters-tools">
      <ion-searchbar
        mode="ios"
        [value]="search()"
        (ionInput)="onSearch($event)"
        [placeholder]="'characters.list.searchPlaceholder' | translate"
        [attr.aria-label]="'characters.list.searchPlaceholder' | translate"
        show-clear-button="focus"
      ></ion-searchbar>
    </div>

    @if (segment() === 'sheets') {
    <ion-refresher slot="fixed" (ionRefresh)="handleRefreshMyCharacters($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    @if (charactersService.myLibrarySheets.isLoading() && !myCharacters()?.length) {
    <ion-list lines="none" class="re-card-list">
      <ion-item>
        <ion-skeleton-text style="height: 1.5rem; width: 80%"></ion-skeleton-text>
      </ion-item>
      <ion-item>
        <ion-skeleton-text style="height: 1.5rem; width: 60%"></ion-skeleton-text>
      </ion-item>
      <ion-item>
        <ion-skeleton-text style="height: 1.5rem; width: 70%"></ion-skeleton-text>
      </ion-item>
    </ion-list>
    } @else if (charactersService.myLibrarySheets.isError()) {
    <div class="characters-empty re-empty-state re-empty-state--compact" role="alert">
      <div class="characters-empty__icon re-empty-state__icon" aria-hidden="true">
        <ion-icon name="alert-circle-outline"></ion-icon>
      </div>
      <p class="characters-empty__title re-empty-state__title">{{ 'common.loadError' | translate }}</p>
      <ion-button class="characters-empty__cta re-empty-state__action" shape="round" (click)="charactersService.myLibrarySheets.refetch()">
        {{ 'common.retry' | translate }}
      </ion-button>
    </div>
    } @else if ((myCharacters()?.length ?? 0) > 0 && filteredCharacters().length > 0) {
    <ion-list lines="none" class="re-card-list">
      @for (character of filteredCharacters(); track character.id; let i = $index) {
      <ion-item [button]="true" [detail]="true" detailIcon="chevron-forward-outline" [routerLink]="[character.id]">
        @if (character.avatar) {
        <ion-avatar slot="start" class="characters-list-avatar">
          <img [src]="character.avatar" [alt]="character.name" />
        </ion-avatar>
        } @else {
        <span slot="start" class="re-list-row-avatar" [class.re-list-row-avatar--amber]="i % 2 === 1"
          aria-hidden="true">
          {{ avatarInitial(character.name) }}
        </span>
        }
        <ion-label>
          <h2 class="re-list-row-title">{{ character.name }}</h2>
          @if (campaignLabel(character); as campaign) {
          <p class="re-list-row-note">{{ campaign }}</p>
          }
        </ion-label>
      </ion-item>
      }
    </ion-list>
    } @else if ((myCharacters()?.length ?? 0) > 0) {
    <p class="characters-no-results">{{ 'characters.list.searchNoResults' | translate }}</p>
    } @else {
    <div class="characters-empty re-empty-state">
      <div class="characters-empty__icon re-empty-state__icon" aria-hidden="true">
        <ion-icon name="people-outline"></ion-icon>
      </div>
      <p class="characters-empty__title re-empty-state__title">{{ 'characters.list.sheetsEmpty' | translate }}</p>
      <p class="characters-empty__hint re-empty-state__description">{{ 'characters.list.sheetsEmptyHint' | translate }}</p>
      <ion-button class="characters-empty__cta re-empty-state__action" [routerLink]="['new']" [queryParams]="{ template: undefined }"
        shape="round">
        {{ 'characters.list.sheetsCreateCta' | translate }}
      </ion-button>
    </div>
    }
    }

    @if (segment() === 'templates') {
    <ion-refresher slot="fixed" (ionRefresh)="handleRefreshMyTemplates($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    @if (charactersService.myTemplates.isLoading() && !myTemplates()?.length) {
    <ion-list lines="none" class="re-card-list">
      <ion-item>
        <ion-skeleton-text style="height: 1.5rem; width: 80%"></ion-skeleton-text>
      </ion-item>
      <ion-item>
        <ion-skeleton-text style="height: 1.5rem; width: 60%"></ion-skeleton-text>
      </ion-item>
      <ion-item>
        <ion-skeleton-text style="height: 1.5rem; width: 70%"></ion-skeleton-text>
      </ion-item>
    </ion-list>
    } @else if (charactersService.myTemplates.isError()) {
    <div class="characters-empty re-empty-state re-empty-state--compact" role="alert">
      <div class="characters-empty__icon characters-empty__icon--amber re-empty-state__icon" aria-hidden="true">
        <ion-icon name="alert-circle-outline"></ion-icon>
      </div>
      <p class="characters-empty__title re-empty-state__title">{{ 'common.loadError' | translate }}</p>
      <ion-button class="characters-empty__cta re-empty-state__action" shape="round" (click)="charactersService.myTemplates.refetch()">
        {{ 'common.retry' | translate }}
      </ion-button>
    </div>
    } @else if ((myTemplates()?.length ?? 0) > 0 && filteredTemplates().length > 0) {
    <ion-list lines="none" class="re-card-list">
      @for (character of filteredTemplates(); track character.id; let i = $index) {
      <ion-item [button]="true" [detail]="true" detailIcon="chevron-forward-outline" [routerLink]="[character.id]">
        <span slot="start" class="re-list-row-avatar" [class.re-list-row-avatar--amber]="i % 2 === 1"
          aria-hidden="true">
          {{ character.name.charAt(0).toUpperCase() }}
        </span>
        <ion-label>
          <h2 class="re-list-row-title">{{ character.name }}</h2>
        </ion-label>
      </ion-item>
      }
    </ion-list>
    } @else if ((myTemplates()?.length ?? 0) > 0) {
    <p class="characters-no-results">{{ 'characters.list.searchNoResultsTemplates' | translate }}</p>
    } @else {
    <div class="characters-empty re-empty-state">
      <div class="characters-empty__icon characters-empty__icon--amber re-empty-state__icon" aria-hidden="true">
        <ion-icon name="grid-outline"></ion-icon>
      </div>
      <p class="characters-empty__title re-empty-state__title">{{ 'characters.list.templatesEmpty' | translate }}</p>
      <p class="characters-empty__hint re-empty-state__description">{{ 'characters.list.templatesEmptyHint' | translate }}</p>
      <ion-button class="characters-empty__cta re-empty-state__action" [routerLink]="['new']" [queryParams]="{ template: true }" shape="round">
        {{ 'characters.list.templatesCreateCta' | translate }}
      </ion-button>
    </div>
    }
    }
  </div>
  <ion-fab slot="fixed" vertical="bottom" horizontal="end">
    <ion-fab-button [routerLink]="['new']" [queryParams]="segment() === 'templates' ? { template: true } : {}"
      [attr.aria-label]="segment() === 'templates' ? ('characters.list.templatesCreateCta' | translate) : ('characters.list.sheetsCreateCta' | translate)">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
